import React from 'react';

const DiscountBadge = ({ className, discountRate }) => {
    return (
        <span
            style={{ height: 'min-content' }}
            className={`badge badge-danger badge-inline ${className || ''}`}
            data-item-card-discount-rate="">
            -{discountRate}%
        </span>
    );
};

export default DiscountBadge;
